import { Box, Text } from '@chakra-ui/react'

interface AvatarProps {
  name?: string
  size?: 'sm' | 'md' | 'lg'
  bg?: string
}

export function Avatar({ name = 'U', size = 'md', bg = 'brand.500' }: AvatarProps) {
  const sizeMap = {
    sm: { w: '32px', h: '32px', fontSize: 'sm' },
    md: { w: '40px', h: '40px', fontSize: 'md' },
    lg: { w: '48px', h: '48px', fontSize: 'lg' },
  }

  const dimensions = sizeMap[size]
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)

  return (
    <Box
      w={dimensions.w}
      h={dimensions.h}
      bg={bg}
      borderRadius="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      color="white"
      fontWeight="semibold"
      fontSize={dimensions.fontSize}
    >
      <Text>{initials}</Text>
    </Box>
  )
}
